import { ArboProperty, PropertyV2Media, PropertyV2Picture } from "../types"

export function discoverMedia(arbo: ArboProperty): PropertyV2Media {
  const media: PropertyV2Media = {
    videos: [],
    tour360: [],
    pictures: []
  }

  if (arbo.fotos && arbo.fotos.length > 0) {
    const sortedPhotos = [...arbo.fotos].sort((a, b) => {
      if (a.principal && !b.principal) return -1
      if (!a.principal && b.principal) return 1
      return (a.ordem || 999) - (b.ordem || 999)
    })

    media.pictures = sortedPhotos.map((foto, index) => ({
      id: generatePhotoId(),
      src: foto.url,
      name: extractFileName(foto.url) || `foto_${index + 1}.jpg`,
      label: extractFileName(foto.url) || `foto_${index + 1}.jpg`
    }))
  }

  if (arbo.url_video) {
    media.videos.push({
      url: arbo.url_video,
      type: "youtube"
    })
  }

  if (arbo.url_tour) {
    media.tour360.push({
      url: arbo.url_tour,
      type: "external"
    })
  }

  return media
}

function generatePhotoId(): string {
  return Math.random().toString().slice(2, 20)
}

function extractFileName(url: string): string {
  try {
    const urlParts = url.split("/")
    const fileName = urlParts[urlParts.length - 1]
    return fileName.split("?")[0]
  } catch {
    return ""
  }
}

export function discoverThumbnails(arbo: ArboProperty, media: PropertyV2Media): string {
  if (media.pictures.length > 0) {
    return media.pictures[0].src
  }

  if (arbo.fotos && arbo.fotos.length > 0) {
    const mainPhoto = arbo.fotos.find(f => f.principal)
    if (mainPhoto) return mainPhoto.url
    return arbo.fotos[0].url
  }

  return ""
}